import { render, staticRenderFns } from "./BudgetViewV2.vue?vue&type=template&id=9b092e8a&scoped=true"
import script from "./BudgetViewV2.vue?vue&type=script&lang=js"
export * from "./BudgetViewV2.vue?vue&type=script&lang=js"
import style0 from "./BudgetViewV2.vue?vue&type=style&index=0&id=9b092e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b092e8a",
  null
  
)

export default component.exports